import { Link, useGetPermissions, usePermissions } from "react-admin";
import { Link as RouterLink } from "react-router-dom";
import { WavePermissions } from "./auth";
import { useEffect, useState } from "react";

const PaymentButton = () => (
    <Link component={RouterLink} to="/payments">
        Go to analytics
    </Link>
);

const InternalDashboard = () => {
    return (
        <div>
            <h1>Welcome to the Carbon music catalog.</h1>
            <p>Use the categories on the left panel to access, edit and add new content.</p>
            <p>
                Need help? Ask us directly on Slack{" "}
                <a href="https://voodoo-team.slack.com/channels/spot-voodoo-music">#spot-voodoo-music</a>
            </p>
            <PaymentButton />
        </div>
    );
};

const ExternalDashboard = () => {
    return (
        <div>
            <h1>Welcome to the Carbon music catalog.</h1>
            <p>Use the categories on the left panel to access content.</p>
        </div>
    );
};

const Dashboard = () => {
    let getPermissions = useGetPermissions();
    let [hasInternalAccess, setHasInternalAccess] = useState(false);

    useEffect(() => {
        getPermissions().then((permissions) => {
            setHasInternalAccess(permissions !== "cms_external");
        });
    }, [getPermissions]);

    return hasInternalAccess ? <InternalDashboard /> : <ExternalDashboard />;
};

export default Dashboard;
